import { TimelapseOutlined } from '@mui/icons-material';
import { Box, Card, CardContent, Stack, SxProps, Typography } from '@mui/material';
import React from 'react';
import TypeChip from '../chip/TypeChip';
import { AssessmentResult, AssessmentScore as IAssessmentScore } from '../types';

export interface AssessmentScoreProps {
  pointsRange: {
    lower: number;
    higher: number;
  };
  passed: boolean;
  score: number;
  scorePercent: number;
  sx?: SxProps;
}

const SquareChip = props => <TypeChip sx={{ borderRadius: '4px', fontWeight: 'bold' }} {...props} />;

const AssessmentScore = ({ pointsRange, passed, score, scorePercent, sx = {} }: AssessmentScoreProps) => (
  <Card sx={sx}>
    <CardContent>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
        <TimelapseOutlined sx={{ color: 'text.secondary' }} />
        <Typography variant="overline">Score</Typography>
      </Box>

      <Stack spacing={2} alignItems="flex-start">
        <SquareChip
          type={passed ? IAssessmentScore.Positive : IAssessmentScore.Negative}
          label={
            <Box display="flex" alignItems="center">
              {scorePercent}% {passed ? AssessmentResult.Passed : AssessmentResult.Failed}
            </Box>
          }
        />
        <div>
          <Typography component="span" variant="h6">
            {score}
          </Typography>{' '}
          <Typography component="span" color="text.secondary">
            current points
          </Typography>
        </div>
        <div>
          <Typography component="span" variant="h6">
            {pointsRange.lower} to {pointsRange.higher}
          </Typography>{' '}
          <Typography component="span" color="text.secondary">
            points range
          </Typography>
        </div>
      </Stack>
    </CardContent>
  </Card>
);

export default AssessmentScore;
